module.exports = "<div class=\"menu_item {{selected}} {{disabled}}\" title=\"{{title}}\">{{text}}</div>";